export default {
  COMMON_SELECT_AT_LEAST_4_HOPES: 0,
  COMMON_HOPEFUL_FOR_MORE: 1,
  COMMON_THATS_IT: 2,

  // on wheel, at the beginning
  DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES: 3,
  // on own totem, at rest
  // on related totem, at rest
  DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA: 4,
  // on own totem, at rest
  DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS: 5,
  // on own totem, exploded
  // on related totem, exploded
  DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA: 6,
  // on own totem, with panel open
  // on related totem, at rest
  DESKTOP_SCROLL_DOWN_TO_GO_BACK: 7,
  // on multitotem == 1
  DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES: 8,

  // on wheel, at the beginning
  MOBILE_SELECT_YOUR_HOPES: 9,
  // on wheel, after x inactivity or tap on empty space
  MOBILE_WHEEL_ANIMATION: 10,
  // on own totem, at rest, after x inactivity or second tap
  MOBILE_EXPLORE_THE_DATA_ANIMATION: 11,
  // on own totem, exploded
  // on related totem, exploded
  MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA: 12,
  // on own totem, exploded
  MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION: 13,
  // on own totem, at rest, after exploded
  MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION: 14,
  // on related totem, exploded
  MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION: 15,
  // on related totem, at rest, after exploded
  MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES: 16,
  // on multitotem == 1
  MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES: 17,
  // on related totem, at rest, after x inactivity or second tap
  MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED: 18
}



// WEBPACK FOOTER //
// ./src/atoms/Hints.js